import { Checkbox } from '@/ui/primitives/checkbox';
import { type EscopoPerfil, type Permissao, ROTULOS_PERMISSOES } from '@fiscoai/contracts';

interface Props {
  escopo: EscopoPerfil;
  marcadas: readonly Permissao[];
  aoMudar: (permissoes: Permissao[]) => void;
  somenteLeitura: boolean;
}

/** Permissões do escopo agrupadas pela área (catálogo do contrato — fonte única). */
export function MatrizPermissoes({ escopo, marcadas, aoMudar, somenteLeitura }: Props) {
  const doEscopo = (Object.keys(ROTULOS_PERMISSOES) as Permissao[]).filter((p) =>
    escopo === 'PLATAFORMA' ? p.startsWith('plataforma.') : !p.startsWith('plataforma.'),
  );
  const grupos = new Map<string, Permissao[]>();
  for (const p of doEscopo) {
    const grupo = ROTULOS_PERMISSOES[p].grupo;
    grupos.set(grupo, [...(grupos.get(grupo) ?? []), p]);
  }
  const alternar = (p: Permissao, valor: boolean) => {
    aoMudar(valor ? [...marcadas, p] : marcadas.filter((x) => x !== p));
  };
  return (
    <div className="grid gap-5 sm:grid-cols-2">
      {[...grupos.entries()].map(([grupo, permissoes]) => (
        <fieldset key={grupo} className="grid content-start gap-2" disabled={somenteLeitura}>
          <legend className="pb-1 text-sm font-semibold text-texto-suave">{grupo}</legend>
          {permissoes.map((p) => (
            <Checkbox
              key={p}
              rotulo={ROTULOS_PERMISSOES[p].rotulo}
              descricao={<span className="font-mono">{p}</span>}
              marcado={marcadas.includes(p)}
              aoMudar={(v) => {
                alternar(p, v);
              }}
              disabled={somenteLeitura}
            />
          ))}
        </fieldset>
      ))}
    </div>
  );
}
